function normalizePath(path) {
  if (!path) return '';
  return String(path).replace(/^\/+/, '');
}

function joinPath() {
  const parts = Array.from(arguments)
    .filter(Boolean)
    .map((p) => normalizePath(p));
  return parts.join('/');
}

/**
 * Local Django returns 404 for `/api/v1/medical_questionarie/` but 401 (route hit) without the
 * trailing slash. Strip trailing slashes and accidental `api/` duplication when paths come from env.
 */
function cleanMedicalQuestionnaireRelativePath(path) {
  if (!path) return '';
  return String(path)
    .trim()
    .replace(/^\/+/, '')
    .replace(/^api\//i, '')
    .replace(/\/+$/, '');
}

const BASE_PATH = normalizePath(process.env.REACT_APP_BASE_PATH || 'v1');

export const ENDPOINTS = {
  AUTH: {
    SIGNUP: joinPath(BASE_PATH, 'auth/signup'),
    LOGIN: joinPath(BASE_PATH, 'auth/login'),
    GOOGLE: joinPath(BASE_PATH, 'auth/google/login'),
    SOCIAL_SYNC: joinPath(BASE_PATH, 'auth/social-sync'),
    REFRESH: joinPath(BASE_PATH, 'token/refresh') + '/',
    FORGOT_PASSWORD: joinPath(BASE_PATH, 'auth/forgot-password'),
    RESET_PASSWORD: joinPath(BASE_PATH, 'auth/reset-password'),
    VERIFY_OTP: joinPath(BASE_PATH, 'auth/verify-otp'),
    RESEND_OTP_EMAIL: joinPath(BASE_PATH, 'auth/resend-otp-email'),
    VERIFY_RESET_TOKEN: joinPath(BASE_PATH, 'auth/verify-reset-token'),
  },
  PROFILE: {
    ME: joinPath(BASE_PATH, 'profile/me'),
    PERSONAL: joinPath(BASE_PATH, 'profile/personal'),
    ACTIVATE_BARCODE: joinPath(BASE_PATH, 'profile/barcode-activate'),
    MARK_ACTIVATE_BARCODE: joinPath(BASE_PATH, 'profile/barcode-mark-activate'),
    MEDICAL: joinPath(BASE_PATH, 'profile/medical-info'),
  },
  MEDICAL_QUESTIONNAIRE: {
    /** GET question definitions (same `BASE_PATH` as other v1 APIs). */
    QUESTIONS: cleanMedicalQuestionnaireRelativePath(joinPath(BASE_PATH, 'medical_questions')),
    FILLED: cleanMedicalQuestionnaireRelativePath(
      process.env.REACT_APP_FILLED_MEDICAL_QUESTIONNAIRE_PATH ||
        joinPath(BASE_PATH, 'medical_questionarie')
    ),
    /** POST partial or full answers; defaults to same path as FILLED unless overridden. */
    SAVE: cleanMedicalQuestionnaireRelativePath(
      process.env.REACT_APP_SAVE_MEDICAL_QUESTIONNAIRE_PATH ||
        joinPath(BASE_PATH, 'medical_questionarie')
    ),
    /** GET section stats + display answers for the read-only summary page. */
    SUMMARY: cleanMedicalQuestionnaireRelativePath(
      joinPath(BASE_PATH, 'medical_questionnaire/summary')
    ),
  },
  SUBSCRIPTION: {
    CREATE: joinPath(BASE_PATH, 'subscribe'),
  },
  BLOOD: {
    SUMMARY: joinPath(BASE_PATH, 'blood/summary'),
    INACTIVE_BARCODES: joinPath(BASE_PATH, 'blood/inactive-barcodes'),
  },
  PRODUCTS: {
    LIST: joinPath(BASE_PATH, 'products'),
    DETAIL: (id) => joinPath(BASE_PATH, `products/${id}`),
  },
  SUPPLEMENT: {
    APPROVE: joinPath(BASE_PATH, 'supplement/approve'),
  },
  SUBSTANCES: {
    LIST: joinPath(BASE_PATH, 'substances'),
  },
  PRESCRIPTION: {
    SUBMIT: joinPath(BASE_PATH, 'prescriptions/submit'),
    UPDATE: joinPath(BASE_PATH, 'prescriptions/update'),
    SEARCH_PRODUCT: joinPath(BASE_PATH, 'prescriptions/product'),
  },
  ORDERS: {
    LIST: joinPath(BASE_PATH, 'orders'),
    DETAILS: (orderId) => joinPath(BASE_PATH, `order/${orderId}`),
    APPROVE: (orderId) => joinPath(BASE_PATH, `orders/${orderId}/approve/`),
    PDF: joinPath(BASE_PATH, 'order/pdf'),
    IMAGES: (orderId) => joinPath(BASE_PATH, `order/${orderId}/images/`),
    PAYMENT_STATUS: (orderId) => joinPath(BASE_PATH, `order/${orderId}/payment-status/`),
  },
  PATIENTS: {
    LIST: joinPath(BASE_PATH, 'patients'),
    LINK: joinPath(BASE_PATH, 'link-patient'),
  },
  AIRTABLE: {
    SYNC: joinPath(BASE_PATH, 'sync-airtable'),
    SYNC_STATUS: (jobId) => joinPath(BASE_PATH, `sync-airtable/${jobId}`),
  },
  EXIT_INTENT: joinPath(BASE_PATH, 'exit_intent'),
  KIT_ASSIGNMENT: {
    DETAIL: joinPath(BASE_PATH, 'kit-assignment'),
  },
};

export default ENDPOINTS;
